export const WORKFLOW_CONFIG_LEAVE_MESSAGE =
  '¿Desea Abandonar sin guardar los cambios Realizados?';

export function withSearch(path: string, search?: string | null): string {
  const qs = (search ?? '').replace(/^\?/, '');
  return qs ? `${path}?${qs}` : path;
}

export function workflowConfigPath(id: string | number, search?: string | null): string {
  return withSearch(`/workflow/${id}/config`, search);
}

export function workflowConfigPeriodoPath(id: string | number, search?: string | null): string {
  return withSearch(`/workflow/${id}/config/periodo`, search);
}

export function shouldHideWorkflowList(pathname: string): boolean {
  return /\/workflow\/\d+\/(diseno|config(?:\/.*)?|workflow-empresa\/\d+\/diseno)$/.test(pathname);
}

export function isWorkflowConfigPeriodoPath(pathname: string): boolean {
  return /\/workflow\/\d+\/config\/periodo\/?$/.test(pathname);
}

/** Overlay de periodo: solo con config cargado, para no titilar al refrescar. */
export function shouldOpenWorkflowPeriodoModal(pathname: string, configReady: boolean): boolean {
  return configReady && isWorkflowConfigPeriodoPath(pathname);
}

export function workflowConfigIdFromPath(pathname: string): string | null {
  const match = pathname.match(/\/workflow\/(\d+)\/config(?:\/periodo)?\/?$/);
  return match ? match[1] : null;
}

/** Permite config ↔ config/periodo del mismo workflow; bloquea el resto. */
export function isWorkflowConfigStayNavigation(
  currentPathname: string,
  nextPathname: string,
): boolean {
  const currentId = workflowConfigIdFromPath(currentPathname);
  const nextId = workflowConfigIdFromPath(nextPathname);
  return currentId != null && currentId === nextId;
}

export type HashRouterHrefNavigation = {
  kind: 'spa' | 'document';
  pathname: string;
  search: string;
  href: string;
};

export function resolveHashRouterHref(
  href: string,
  origin = 'http://localhost',
): HashRouterHrefNavigation | null {
  const trimmed = href.trim();
  if (!trimmed || /^(mailto:|tel:|javascript:)/i.test(trimmed)) return null;

  const fromHash = (hash: string, fallbackHref: string): HashRouterHrefNavigation => {
    const raw = hash.replace(/^#/, '');
    const [pathPart, searchPart] = raw.split('?');
    return {
      kind: 'spa',
      pathname: pathPart || '/',
      search: searchPart ? `?${searchPart}` : '',
      href: fallbackHref,
    };
  };

  if (trimmed.startsWith('#')) {
    const raw = trimmed.replace(/^#/, '');
    if (!raw.startsWith('/')) return null;
    return fromHash(trimmed, trimmed);
  }

  try {
    const url = new URL(trimmed, origin);
    if (url.origin !== origin && /^https?:/i.test(trimmed)) return null;
    if (url.hash.startsWith('#/')) {
      return fromHash(url.hash, `${url.hash}`);
    }
    return {
      kind: 'document',
      pathname: url.pathname || '/',
      search: url.search,
      href: url.href,
    };
  } catch {
    return null;
  }
}
